export const addTrackingEventListener = (name, callback) => {
    document.addEventListener(name, callback);
};
export const GTMScript = (code = "GTM-57WFMN3") => {
    const element = document.createElement("script");
    element.innerHTML = `(function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js'
        });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', "${code}");`;
    return element;
};
export const GTMNoScript = (code) => {
    const element = document.createElement("noscript");
    element.innerHTML = `<iframe src="//www.googletagmanager.com/ns.html?id=${code}"
                height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    return element;
};
//# sourceMappingURL=helpers.js.map